import { Alert, Snackbar } from 'components/mui';
import {
	hideNotificationBar,
	showNotificationBarState,
} from 'redux/notificationBar/notificationBarSlice';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function NotificationBar() {
	const dispatch = useDispatch();
	const state = useSelector(showNotificationBarState);

	useEffect(() => {
		if (state.open) {
			const interval = setInterval(() => {
				dispatch(hideNotificationBar());
			}, state.duration);
			return () => clearInterval(interval);
		}
	}, [dispatch, state]);

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		dispatch(hideNotificationBar());
	};

	return (
		<Snackbar
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'center',
			}}
			open={state.open}
			onClose={handleClose}
		>
			{state.severity !== '' ? (
				<Alert
					onClose={handleClose}
					severity={state.severity}
					variant="filled"
				>
					{state.message}
				</Alert>
			) : null}
		</Snackbar>
	);
}
